require('./styles/main.scss');
import { TourManager } from './logic/tourManager';
import { TourViewer } from './viewer/tourViewer';
import { TourConfig } from '..';
import { AssistantOperation } from './types/assistant-actions';
import { IAssistantTask, IAssistantAction } from './types/assistant';

class TourMaker {
  private isInit = false;
  private tourManager: TourManager = null;
  private tourConfig: TourConfig;

  public config(tourConfig: TourConfig = {}): void {
    this.tourConfig = tourConfig;

    if (tourConfig.shouldInitOnConfig) {
      this.init();
    }
  }

  public async startTask(task): Promise<AssistantOperation> {
    if (!this.isInit) {
      this.init();
    }

    return this.tourManager.startTask(task);
  }

  public async stopActiveTask() {
    if (this.tourManager) {
      return this.tourManager.stopActiveTask();
    }
  }

  public stop(): void {
    if (this.tourManager) {
      this.tourManager.stop();
    }
  }

  public stopAndCompleteActiveTask(): void {
    if (this.tourManager) {
      this.tourManager.stopAndComplete();
    }
  }

  public gotoNextAction(): void {
    if (this.tourManager) {
      this.tourManager.gotoNextAction();
    }
  }

  public gotoPrevAction(): void {
    if (this.tourManager) {
      this.tourManager.gotoPrevAction();
    }
  }

  public gotoActionInActiveTask(actionIndex: number): void {
    if (this.tourManager) {
      this.tourManager.gotoActionInActiveTask(actionIndex);
    }
  }

  public isInActiveTask(): boolean {
    if (this.tourManager) {
      return this.tourManager.isInActiveTask();
    }

    return false;
  }

  public getActiveTask(): IAssistantTask {
    if (this.tourManager) {
      return this.tourManager.getActiveTask();
    }

    return null;
  }

  public getActiveAction(): IAssistantAction {
    if (this.tourManager) {
      return this.tourManager.getActiveAction();
    }

    return null;
  }

  public setCustomTaskData(key: string, value: any) {
    if (this.tourManager) {
      this.tourManager.setCustomTaskData(key, value);
    }
  }

  public getCustomTaskData(key: string): any {
    if (this.tourManager) {
      return this.tourManager.getCustomTaskData(key);
    }
  }

  private init(): void {
    if (this.isInit) {
      return;
    }

    if (!this.tourConfig) {
      throw new Error(
        `Tour Maker wasn't configured, please call the cofig method before starting a task.`,
      );
    }

    const tourViewer = new TourViewer(this.tourConfig);
    tourViewer.init();
    this.tourManager = new TourManager(tourViewer, this.tourConfig);
    this.isInit = true;
  }
}

export const tourMaker = new TourMaker();
